module.exports = {
      id: "point-arrow-usage",
      viewBox: "0 0 16 17",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#point-arrow",
      toString: function () {
        return this.url;
      }
    }